import React, { useState } from "react";
import { Pagination } from "antd";
import { flushSync } from "react-dom";

const CustomizedTable = ({
  columns,
  rows,
  page,
  setPage,
  count,
  pageSize,
  sortHandler,
  sorts,
  setRows,
  setPageSize,
  tableStyle = {},
}) => {
  const [sortBy, setSortBy] = useState({
    column: null,
    order: "asc",
  });

  const handleSort = (column) => {
    if (sorts) {
      sortHandler?.({ columnKey: column });
      return;
    }

    const newOrder =
      sortBy.column === column && sortBy.order === "asc" ? "descend" : "ascend";

    sortHandler?.({
      columnKey: column,
      order: newOrder,
    });

    setSortBy({
      column,
      order: newOrder === "ascend" ? "asc" : "desc",
    });
  };

  const onChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const onSizeChange = (current, newPageSize) => {
    flushSync(() => {
      setPage(1);
      setPageSize(newPageSize);
    });
  };

  const hasGroups = columns.some((c) => c.children?.length);
  const flatColumns = columns.flatMap((c) => c.children?.length ? c.children : [c]);
  const totalCols = columns.reduce((acc, c) => acc + (c.children?.length || 1), 0);
  const childHeaderRow = hasGroups
    ? columns.flatMap((item) =>
        (item.children || []).map((child, ci) => (
          <th key={child.key || ci} style={{ width: child?.width ? child.width + "px" : "auto" }}>
            {child.title}
          </th>
        ))
      )
    : [];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <div className="table_holder divcontainer">
        <table id="voucher_list" className="table table-bordered table-striped" style={tableStyle}>
          <thead>
            <tr>
              {columns.map((item, index) =>
                item.children?.length ? (
                  <th key={item.key || index} colSpan={item.children.length} style={{ textAlign: "center" }}>
                    {item.title}
                  </th>
                ) : (
                  <th
                    key={item.key || index}
                    rowSpan={hasGroups ? 2 : 1}
                    onClick={() => item?.sorter && handleSort(item.key)}
                    style={{
                      width: item?.width ? item.width + "px" : "auto",
                      cursor: item?.sorter ? "pointer" : "default",
                      verticalAlign: hasGroups ? "middle" : undefined,
                    }}
                  >
                    <span>{item.title}</span>
                    {item?.sorter && (() => {
                      const idx = sorts ? sorts.findIndex((x) => x.columnKey === item.key) : -1;
                      const active = sorts ? sorts[idx]?.order : sortBy.column === item.key ? sortBy.order : null;
                      return (
                        <span style={{ marginLeft: "10px" }}>
                          <span style={{ color: active === "asc" ? "red" : "grey" }}>↑</span>
                          <span style={{ color: active === "desc" ? "red" : "grey" }}>↓</span>
                          {sorts?.length > 1 && idx >= 0 && (
                            <sup style={{ color: "red", marginLeft: "2px" }}>{idx + 1}</sup>
                          )}
                        </span>
                      );
                    })()}
                  </th>
                )
              )}
            </tr>
            {hasGroups && <tr>{childHeaderRow}</tr>}
          </thead>
          <tbody>
            {!rows?.length ? (
              <tr>
                <td colSpan={totalCols} className="dataTables_empty" style={{ textAlign: "center", padding: "20px 0" }}>
                  No matching records found
                </td>
              </tr>
            ) : rows.map((row, index) => (
              <tr key={row.id || index}>
                {flatColumns.map((item) => (
                  <td key={item.key || item.dataIndex} style={{ minWidth: item?.width, height: "auto" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent:
                          item.align === "left" ? "flex-start" : item.align === "right" ? "flex-end" : "center",
                        width: "100%",
                        height: "100%",
                        textAlign: item.align || "center",
                        paddingLeft: item.align === "left" ? "10px" : "0",
                      }}
                    >
                      {item.render
                        ? item.render(row[item.dataIndex ?? item.key], row, index)
                        : row[item.dataIndex ?? item.key]}
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {count > 0 && (count > 5 || page > 1) && (
        <Pagination
          key={`${page}-${pageSize}`}
          showSizeChanger
          pageSizeOptions={["5", "10", "20", "50"]}
          onShowSizeChange={onSizeChange}
          current={page}
          onChange={onChange}
          total={count}
          pageSize={pageSize}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} items`
          }
          style={{ marginTop: "10px", marginBottom: "10px", marginLeft: "auto", paddingRight: "10px" }}
        />
      )}
    </div>
  );
};

export default CustomizedTable;


/*  OLD CODE ----------------------------------------------------------------------------------------------------------

import React, { useEffect, useState } from "react";
import { Pagination } from "antd";

const CustomizedTable = ({
  columns,
  rows,
  page,
  setPage,
  count,
  pageSize,
  sortHandler,
  setRows,
  setPageSize,
  tableStyle = {},
}) => {
  const [sortBy, setSortBy] = useState({
    column: null,
    order: "asc",
  });

  const handleSort = (column) => {
    const newOrder =
      sortBy.column === column && sortBy.order === "asc" ? "descend" : "ascend";

    sortHandler({
      columnKey: column,
      order: newOrder,
    });

    setSortBy({
      column,
      order: newOrder === "ascend" ? "asc" : "desc",
    });
  };

  const onChange = (pageNumber) => {
    setPage(pageNumber);
    setRows([]); // optionally clear rows while fetching new data
  };

  const onSizeChange = (current, newPageSize) => {
    setPage(1);
    setPageSize(newPageSize);
    setRows([]);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <div className="table_holder divcontainer">
        <table
          id="voucher_list"
          className="table table-bordered table-striped"
        >
          <thead>
            <tr>
              {columns.map((item, index) => (
                <th
                  key={item.key || index}
                  onClick={() => item?.sorter && handleSort(item.key)}
                  style={{
                    width: item?.width ? item.width + "px" : "auto",
                    cursor: item?.sorter ? "pointer" : "default",
                  }}
                >
                  <span>{item.title}</span>
                  {item?.sorter && (
                    <span style={{ marginLeft: "10px" }}>
                      <span
                        style={{
                          color:
                            sortBy.column === item.key && sortBy.order === "asc"
                              ? "red"
                              : "grey",
                        }}
                      >
                        ↑
                      </span>
                      <span
                        style={{
                          color:
                            sortBy.column === item.key && sortBy.order === "desc"
                              ? "red"
                              : "grey",
                        }}
                      >
                        ↓
                      </span>
                    </span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows?.length > 0 ? (
              rows.map((row, index) => (
                <tr key={row.id || index}>
                  {columns.map((item) => (
                    <td
                      key={item.key || item.dataIndex}
                      style={{ minWidth: item?.width, height: "auto" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        {item.render
                          ? item.render(row[item.key], row, index)
                          : row[item.key]}
                      </div>
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className="dataTables_empty"
                  style={{ textAlign: "center", padding: "20px 0" }}
                >
                  No matching records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {count > 0 && (
        <Pagination
          showSizeChanger
          pageSizeOptions={["5", "10", "20", "50"]}
          onShowSizeChange={onSizeChange}
          current={page}
          onChange={onChange}
          total={count}
          style={{ marginTop: "10px", marginLeft: "auto" }}
        />
      )}
    </div>
  );
};

export default CustomizedTable;


*/